import Page500 from ".";

export default [
  {
    path: "500",
    element: <Page500 />,
  },
];
